export default __webpack_public_path__ + "static/media/IC-IntegrationIC7.c2b956ef.png";